import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CustomerOwnedLandingPage from './pages/CustomerOwnedLandingPage';
import CustomerOwnedServiceOptionsPage from './pages/CustomerOwnedServiceOptionsPage';
import CustomerOwnedAddServicePage from './pages/CustomerOwnedAddServicePage';
import CustomerOwnedSummaryPage from './pages/CustomerOwnedSummaryPage';
import CustomerOwnedPhotoUploadPage from './pages/CustomerOwnedPhotoUploadPage';

interface CustomerOwnedViewProps {
  storeId: string;
  externalIdentity: string;
  cartId: string;
  productId: string;
}

export const CustomerOwnedViewRoutes: React.FC<CustomerOwnedViewProps> = ({ externalIdentity, cartId }) => (
  <Routes>
    <Route path="/" element={<CustomerOwnedLandingPage externalIdentity={externalIdentity} cartId={cartId} />} />
    <Route path="/service" element={<CustomerOwnedServiceOptionsPage externalIdentity={externalIdentity} />} />
    <Route path="/services/details/:serviceId" element={<CustomerOwnedAddServicePage />} />
    <Route path="/summary" element={<CustomerOwnedSummaryPage externalIdentity={externalIdentity} cartId={cartId} />} />
    <Route path="/photo-upload" element={<CustomerOwnedPhotoUploadPage externalIdentity={externalIdentity} />} />
  </Routes>
);
